import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableComponent } from '../../table/table.component';
import { ColumnComponent } from '../../table/column.component';
import { ToolbarButtonComponent } from '../../buttons/toolbar-button.component';
import { MenuComponent } from '../../panels/menu.component';
import { Action } from '../../../../models/core/action';
import { EmployeeValue } from '../../../../models/api/alerts/alert';
import { dialogPaginatorDropdownStyles } from '../../table/dialog-paginator-dropdown.styles';

@Component({
  selector: 'app-claimants',
  standalone: true,
  host: {
    '[class.dialog-table-paginator-dropdown-self]':
      "paginatorDropdownAppendTo === 'self'",
  },
  imports: [
    TableComponent,
    ColumnComponent,
    ToolbarButtonComponent,
    MenuComponent,
  ],
  template: `<app-table
      [dataSource]="items"
      recordLabel="individual"
      dataKey="empUnum"
      [showActions]="true"
      [showSelection]="true"
      (actionClick)="actionMenu.toggle($event)"
      emptyMessage="Click to add individual"
      emptyIcon="fa-light fa-user"
      [paginatorDropdownAppendTo]="paginatorDropdownAppendTo"
      (selectedEvent)="onSelectedChanged($event)"
    >
      <app-column name="lastName" label="last name" />
      <app-column name="firstName" label="first name" />
      <app-column name="ssn" label="ssn" />
      <app-column name="employeeID" label="Employee ID" />
      <app-column name="dateHire" label="Hire Date" format="d" sortName="hireDateValue" />
      <app-column name="recSource" label="source" />
      @if (showDeleteColumn) {
        <app-column name="action" label="action" [sort]="false">
          <ng-template #value let-data>
            <app-toolbar-button type="Compact" icon="fa-light fa-trash-can" (click)="onDelete(data)" />
          </ng-template>
        </app-column>
      }
    </app-table>
    <app-menu [items]="actions" #actionMenu (click)="onAction($event)" />`,
  styles: dialogPaginatorDropdownStyles,
})
export class ClaimantsComponent {
  @Input()
  items: EmployeeValue[] = [];

  @Input()
  paginatorDropdownAppendTo: 'body' | 'self' = 'body';

  @Input()
  showDeleteColumn = true;

  @Output()
  selected = new EventEmitter<boolean>();

  @Output()
  selectionChanged = new EventEmitter<EmployeeValue[]>();

  @Output()
  itemsChange = new EventEmitter<EmployeeValue[]>();

  selectedItems: EmployeeValue[] = [];

  onSelectedChanged(event: EmployeeValue[]) {
    this.selectedItems = event ?? [];
    this.selected.emit(this.selectedItems.length > 0);
    this.selectionChanged.emit(this.selectedItems);
  }

  actions: Action[] = [{ label: 'Delete selected' }, { label: 'Delete all' }];

  onDelete(item: EmployeeValue) {
    this.items = this.items.filter((i) => i.empUnum !== item.empUnum);
    this.selectedItems = this.selectedItems.filter((i) => i.empUnum !== item.empUnum);
    this.selected.emit(this.selectedItems.length > 0);
    this.selectionChanged.emit(this.selectedItems);
    this.itemsChange.emit(this.items);
  }

  onAction(event: Action) {
    if (!event?.label) return;

    if (event.label === 'Delete selected') {
      const selectedIds = new Set(
        this.selectedItems.map((item) => item.empUnum),
      );
      this.items = this.items.filter((item) => !selectedIds.has(item.empUnum));
    } else {
      this.items = [];
    }

    this.selectedItems = [];
    this.selected.emit(false);
    this.selectionChanged.emit([]);
    this.itemsChange.emit(this.items);
  }
}
